import React from 'react';
import { useDispatch } from 'react-redux';
import ContentConstants from '../../../contentConstants';
import { ActionCreators } from '../../../store/SurveyStore';
import { Col3Col9, Crumblist, ISelectOption, SearchBoxWithFilter } from '@aon/aon-tws-common-ui';
import { LabelAbove } from '@aon/tws-common-ui-questions/build/lib/components/common';
import { SurveyHelper } from '../../../utilities';
import _ from 'lodash';
import { CrumblistContainer } from '../../common';

export interface ISurveyDefaultLanguageProps {
	availableDefaultCultures: ISelectOption[];
	culturesLoading: boolean;
	selectedDefaultCultures: ISelectOption[];
	surveyId: number;
}

export function SurveyDefaultLanguage(props: ISurveyDefaultLanguageProps) {
	const { availableDefaultCultures, culturesLoading, selectedDefaultCultures } = props;
	const dispatch = useDispatch();

	const selectedDefaultCultureCrumbs = SurveyHelper.getCrumbsFromSelectOptions(selectedDefaultCultures);

	function handleDefaultCultureSelect(cultures: ISelectOption[]) {
		const cultureCodes = _.map(cultures, (c: ISelectOption) => c.name);
		// Since the survey default culture always has value which is the first item in the array,
		// The newly selected option would be appended as 2nd item for SearchBoxWithFilter
		dispatch(ActionCreators.UpdateSurveyDefaultCulture(cultureCodes[1]));
	}

	return (
		<Col3Col9 className='tws-survey-default-language' label={ContentConstants.SUBSECTIONHEADERS_DEFAULT_LANGUAGE}>
			<LabelAbove type='input'>{ContentConstants.SECTION_DESCRIPTION_DEFAULT_LANGUAGE}</LabelAbove>
			{!culturesLoading && (
				<SearchBoxWithFilter
					placeholderText={ContentConstants.INPUT_PLACEHOLDER_SEARCH_FOR_LANGUAGES}
					items={availableDefaultCultures}
					selected={selectedDefaultCultures}
					select={handleDefaultCultureSelect}
					filterOutSelected={true}
				/>
			)}
			<CrumblistContainer>
				{selectedDefaultCultureCrumbs.length > 0 && <Crumblist enableDismiss={false} data={selectedDefaultCultureCrumbs} />}
			</CrumblistContainer>
		</Col3Col9>
	);
}
